.burger {
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;

    svg {
        width: 21px;
    }
}

@keyframes slide-in {
    from {
        transform: translateX(-100%);
    }

    to {
        transform: translateX(0%);
    }
}

@keyframes slide-out {
    from {
        transform: translateX(0%);
    }

    to {
        transform: translateX(-100%);
    }
}

.content {
    background: var(--color-white);
    height: 100vh;
    left: 0;
    padding: 1rem;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 1000;

    &[data-state="open"] {
        animation: slide-in 0.5s cubic-bezier(0.19, 1, 0.22, 1);
    }

    &[data-state="closed"] {
        animation: slide-out 0.5s cubic-bezier(0.19, 1, 0.22, 1);
    }
}

.loginLink {
    border-bottom: 1px solid var(--color-kingly-cloud);
    color: var(--color-black);
    display: block;
    font-size: 12px;
    margin: 0 0 20px;
    padding: 20px 0;
}

.primaryNav {
    display: flex;
    flex-direction: column;
    gap: 20px;

    & > a {
        color: var(--color-black);
        font-weight: 700;
        text-decoration: none;
    }
}

.secondaryNav {
    border-bottom: 1px solid var(--color-kingly-cloud);
    border-top: 1px solid var(--color-kingly-cloud);
    display: flex;
    flex-direction: column;
    font-size: 12px;
    gap: 16px;
    margin: 20px 0;
    padding: 10px 0;

    & > a {
        color: var(--color-mid-gray);
        text-decoration: none;
    }
}

.socialMediaRow {
    justify-content: center;
}
